import {
  Col,
  Input,
  Modal,
  Row,
  Select,
  Skeleton,
  Space,
  Table,
  Tooltip,
} from "antd";
import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Paragraph,
  Title,
} from "Components/CommonComponents/GeneralComponents";
import "./index.css";
import PropTypes from "prop-types";
import { ToastContextDispatch } from "Context/CommonContext";
import {
  DislikeFilled,
  DislikeOutlined,
  InfoCircleOutlined,
  LikeFilled,
  LikeOutlined,
} from "@ant-design/icons";
import ReportLog from "./ReportLogo.svg";
import QuestionTextProvider from "Components/CommonComponents/QuestionTextProvider";
import QuestionSlider from "Pages/Questions/QuestionsHomeScreen/QuestionsSlider";
import {
  getAPIRequest,
  putPostRequest,
} from "utilFunctions/Axios/AxiosRequestConfiguration";
import { BASE_URL } from "utilFunctions/Constants/urlConstants";
import { getAppendImgUrl } from "Pages/Questions/QuestionsHomeScreen/QuestionsTable";
import styled from "styled-components";
export const StyledMainDiv = styled("div")`
  margin-top: 16px;
  margin-right: ${({ screen }) =>
    ["xxl", "xl", "lg"].includes(screen) ? "16px" : "0px"};
  margin-left: ${({ screen }) =>
    ["xxl", "xl", "lg"].includes(screen)
      ? "xxl" === screen
        ? "44px"
        : "16px"
      : "0px"};
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const HeaderCell = styled.div`
  background-color: ${(props) => props.bgColor};
  color: black;
  font-weight: 500;
  padding: 8px;
  margin: -16px -8px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ConceptStatusSquare = styled.input`
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 24px;
  height: 24px;
  border: 2px solid ${(props) => props.borderColor};
  background-color: transparent;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};
  margin: 0 auto;
  border-radius: 8px;
  position: relative;
  display: block;
  outline: none;

  &:checked::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 14px;
    height: 14px;
    background-color: ${(props) => props.borderColor};
    border-radius: 8px;
  }
`;
const hintOptions = [
  { label: "Point Hint", value: "pointHint" },
  { label: "Teach Hint", value: "teachHint" },
  { label: "Analogy Hint", value: "analogyHint" },
  { label: "Bottomout Hint", value: "bottomoutHint" },
  { label: "AI Generated Solution", value: "aiSolution" },
  { label: "Faculty Written Solution", value: "facultySolution" },
];
const hintsTooltipMsg = {
  pointHint:
    "Pointing hints mention problem conditions that should remind the student of the knowledge component’s relevance",
  teachHint:
    "Teaching hints describe the knowledge component briefly and show how to apply it",
  analogyHint:
    "Provide a relatable example or comparison to help the user understand the problem and the concept.",
  bottomoutHint: "Bottom-out hints tell the student the steps",
  aiSolution: "Solution is generated by an AI model.",
  facultySolution: "Solution is manually created by faculty members.",
  concept:
    "Concepts are the building blocks of the problem. They are the key ideas that the student needs to understand in order to solve the problem.",
};
const { TextArea } = Input;
const AIHintSliderMain = (props) => {
  const { question, closeQuesContentSlider, setRefresh, setUserVerifiedCount } =
    props;
  const ToastDispatch = useContext(ToastContextDispatch);
  const [questionContent, setQuestionContent] = useState(null);
  const [questionDetailsstate, setquestionDetailsstate] = useState({
    question: null,
    loading: false,
    error: null,
    qBP: {},
  });
  const [conceptStatuses, setConceptStatuses] = useState({});
  const [isAlreadyVerified, setIsAlreadyVerified] = useState(false);
  const [editIndex, setEditIndex] = useState([]);
  const [selectedIssue, setSelectedIssue] = useState(null);
  const [reportIssueModal, setReportIssueModal] = useState(null);
  const fetchQuestionDetails = async (question) => {
    let id = question.questionId;
    let url = BASE_URL + "bulkHint/view?questionId=" + id;
    setquestionDetailsstate({ question: null, loading: true, error: null });
    getAPIRequest({
      url,
      success: (response) => {
        const data = response?.data;
        if (data["data"]) {
          let newDataObj = {
            ...data["data"],
            questionId: id,
            questionStatus: data["data"]["status"],
          };

          let qBP = {};
          hintOptions.map(
            (el) =>
              (qBP[`${el.value}`] =
                el.value == "aiSolution"
                  ? data["data"][`${el.value}`]
                  : data["data"][`${el.value}Ai`])
          );
          setquestionDetailsstate((prevQuestionDetailsState) => ({
            question: {
              ...prevQuestionDetailsState.question,
              ...newDataObj,
            },
            qBP: {
              ...prevQuestionDetailsState.qBP,
              ...qBP,
            },
            loading: false,
            error: null,
          }));
        }
      },
      failure: (data) => {
        if (data["code"] == "429") {
          setquestionDetailsstate({
            question: null,
            loading: false,
            error: null,
          });
        } else {
          ToastDispatch({
            isOpen: true,
            type: "Error",
            message:
              "AI Generated Hint and Solution Not found for this question",
          });
          setquestionDetailsstate({
            question: null,
            loading: false,
            error: null,
          });
        }
      },
    });
  };
  const fetchQuestionContent = async (question) => {
    let id = question.questionId;
    let url = BASE_URL + "questionLanguage?questionId=" + id;
    getAPIRequest({
      url,
      success: (response) => {
        const data = response?.data;
        setQuestionContent(data["data"] || [{ language: "en" }]);
        setquestionDetailsstate((prevQuestionDetailsState) => ({
          question: {
            ...prevQuestionDetailsState.question,
            facultySolution: data["data"][0]["solution"],
          },
          qBP: {
            ...prevQuestionDetailsState.qBP,
            facultySolution: data["data"][0]["solution"],
          },
          loading: false,
          error: null,
        }));
      },
      failure: (data) => {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: data["message"] || data["msg"],
        });
      },
    });
  };
  const fetchQuestionConcepts = async (question) => {
    let id = question.questionId;
    let url = BASE_URL + "bulkHint/view/questionConcepts?questionId=" + id;
    setquestionDetailsstate({ question: null, loading: true, error: null });
    setIsAlreadyVerified(false);
    setConceptStatuses({});
    getAPIRequest({
      url,
      success: (response) => {
        const data = response?.data;
        if (data["data"]) {
          if (data["data"]?.["alreadyVerifiedConcepts"]?.length > 0) {
            setIsAlreadyVerified(true);
            const initialStatuses = {};
            data["data"]["alreadyVerifiedConcepts"].forEach((item) => {
              initialStatuses[item.conceptId] = item.status.toLowerCase();
            });
            setConceptStatuses(initialStatuses);
          }
          if (data["data"]?.["concepts"]?.length > 0) {
            setquestionDetailsstate((prevQuestionDetailsState) => ({
              question: {
                ...prevQuestionDetailsState.question,
                ...data["data"],
              },
              loading: false,
              error: null,
            }));
          }
        }
      },
      failure: (data) => {
        if (data["code"] == "429") {
          setquestionDetailsstate({
            question: null,
            loading: false,
            error: null,
          });
        } else {
          ToastDispatch({
            isOpen: true,
            type: "Error",
            message:
              "AI Generated Hint and Solution Not found for this question",
          });
          setquestionDetailsstate({
            question: null,
            loading: false,
            error: null,
          });
          setIsAlreadyVerified(false);
          setConceptStatuses({});
        }
      },
    });
  };

  useEffect(() => {
    fetchQuestionDetails(question);
    fetchQuestionContent(question);
    fetchQuestionConcepts(question);
  }, [question]);

  const handleAiFeedback = (name, value) => {
    let newQuestionCopy = { ...questionDetailsstate?.question };
    newQuestionCopy[`${name}Feedback`] = value;
    setquestionDetailsstate((prevquestionDetailsstate) => ({
      ...prevquestionDetailsstate,
      question: { ...prevquestionDetailsstate.question, ...newQuestionCopy },
    }));
  };
  const handleEditFeedback = (name) => {
    if (editIndex.includes(name)) {
      let newEditArray = editIndex.filter((item) => item != name);
      setEditIndex([newEditArray]);
    } else {
      setEditIndex((prev) => [...prev, name]);
    }
  };
  const handleEditedFeedback = (name, e) => {
    let newQuestionCopy = { ...questionDetailsstate?.question };
    if (name.includes("Solution")) {
      newQuestionCopy[`${name}`] = e.target.value;
      newQuestionCopy[`${name}User`] = e.target.value;
    } else {
      newQuestionCopy[`${name}Ai`] = e.target.value;
      newQuestionCopy[`${name}User`] = e.target.value;
    }
    setquestionDetailsstate((prevquestionDetailsstate) => ({
      ...prevquestionDetailsstate,
      question: { ...prevquestionDetailsstate.question, ...newQuestionCopy },
    }));
  };
  const handleResetFeedback = (name) => {
    let newQuestionCopy = { ...questionDetailsstate?.question };
    if (name.includes("Solution")) {
      newQuestionCopy[`${name}`] = questionDetailsstate?.qBP[`${name}`];
      delete newQuestionCopy[`${name}User`];
    } else {
      newQuestionCopy[`${name}Ai`] = questionDetailsstate?.qBP[`${name}`];
      delete newQuestionCopy[`${name}User`];
    }

    setquestionDetailsstate((prevquestionDetailsstate) => ({
      ...prevquestionDetailsstate,
      question: { ...newQuestionCopy },
    }));
  };

  const handleConceptStatusChange = (conceptId, status) => {
    if (isAlreadyVerified) return;
    setConceptStatuses((prev) => ({
      ...prev,
      [conceptId]: status,
    }));
  };
  const handleSaveFeedback = (questionDetailsstate, isReported) => {
    let newObj = {
      questionId: question.questionId,
      hintGenerationId: questionDetailsstate?.question?.generationId,
      pointHintUser: isReported
        ? null
        : questionDetailsstate?.question?.pointHintUser ?? null,
      teachHintUser: isReported
        ? null
        : questionDetailsstate?.question?.teachHintUser ?? null,
      analogyHintUser: isReported
        ? null
        : questionDetailsstate?.question?.analogyHintUser ?? null,
      bottomoutHintUser: isReported
        ? null
        : questionDetailsstate?.question?.bottomoutHintUser ?? null,
      aiSolutionUser: isReported
        ? null
        : questionDetailsstate?.question?.aiSolutionUser ?? null,
      pointHintFeedback: isReported
        ? false
        : questionDetailsstate?.question?.pointHintFeedback,
      teachHintFeedback: isReported
        ? false
        : questionDetailsstate?.question?.teachHintFeedback,
      analogyHintFeedback: isReported
        ? false
        : questionDetailsstate?.question?.analogyHintFeedback,
      bottomoutHintFeedback: isReported
        ? false
        : questionDetailsstate?.question?.bottomoutHintFeedback,
      aiSolutionFeedback: isReported
        ? false
        : questionDetailsstate?.question?.aiSolutionFeedback,
      facultySolutionFeedback: isReported
        ? false
        : questionDetailsstate?.question?.facultySolutionFeedback,
      facultySolutionUser: isReported
        ? null
        : questionDetailsstate?.question?.facultySolutionUser ?? null,
      verifiedConcepts: isReported
        ? null
        : Object.entries(conceptStatuses).map(([conceptId, status]) => ({
            conceptId: parseInt(conceptId),
            status: status.toUpperCase(),
          })),
    };

    if (!isReported) {
      const concepts = questionDetailsstate?.question?.concepts || [];
      const allConceptsHaveStatus = concepts.every(
        (concept) => conceptStatuses[concept.conceptId]
      );

      if (concepts.length > 0 && !allConceptsHaveStatus) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message:
            "Please give feedbacks for all hints, solutions and concepts.",
        });
        return;
      }
    }
    if (isReported) {
      newObj["questionReporting"] = selectedIssue;
      delete newObj["verifiedConcepts"];
    }
    putPostRequest({
      url: BASE_URL + "bulkHint/saveFeedback",
      success: (data) => {
        setTimeout(() => {
          setRefresh(new Date().getMilliseconds());
          if (isReported) {
            handleReport();
            closeQuesContentSlider();
            setSelectedIssue(null);
          }
          setEditIndex([]);
          setUserVerifiedCount(
            (prevUserVerifiedCount) => parseInt(prevUserVerifiedCount) + 1
          );
          setConceptStatuses({});
          ToastDispatch({
            isOpen: true,
            type: "Success",
            message: data["message"] || "Success",
          });
          setIsAlreadyVerified(false);
        }, 1000);
      },
      failure: (err) => {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message:
            err?.response?.data?.code == "400"
              ? err?.response?.data?.message
              : "Something went wrong",
        });
      },
      body: newObj,
      method: "Post",
    });
  };
  const handleResetAllFeedback = () => {
    closeQuesContentSlider();
    setquestionDetailsstate({
      question: null,
      loading: false,
      error: null,
      qBP: {},
    });
  };
  const returnTooltipMsg = (type) => {
    return hintsTooltipMsg[type];
  };

  const handleReport = () => {
    setReportIssueModal(!reportIssueModal);
  };
  const handleChange = (e) => {
    setSelectedIssue(e);
  };
  const saveReportQuestion = (quesDetailsState) => {
    handleSaveFeedback(quesDetailsState, true);
  };
  console.log(questionContent, "questionContent", questionDetailsstate);
  return (
    <>
      <Modal
        title={"Report This Question"}
        keyboard={false}
        backdrop="static"
        open={reportIssueModal}
        onCancel={() => handleReport()}
        centered={true}
        width={445}
        footer={false}
      >
        <div className="d-flex flex-column align-items-start justify-content-start w-100">
          <Select
            value={selectedIssue}
            style={{
              width: 400,
            }}
            placeholder="Select reason"
            onChange={(e) => handleChange(e, questionDetailsstate)}
            options={[
              {
                label: "Incorrect question",
                value: "Incorrect question",
              },
              {
                label: "Incorrect answer",
                value: "Incorrect answer",
              },
            ]}
          />
          <Space
            style={{
              marginTop: "24px",
            }}
          >
            <Button type="default" onClick={() => handleReport()}>
              Cancel
            </Button>
            <Button
              type="primary"
              disabled={selectedIssue != null ? false : true}
              onClick={() => {
                saveReportQuestion(questionDetailsstate);
              }}
            >
              Save
            </Button>
          </Space>
        </div>
      </Modal>
      <QuestionSlider
        mode="AIHint"
        question={question}
        closeQuesContentSlider={closeQuesContentSlider}
      />
      {!questionDetailsstate.loading ? (
        questionDetailsstate.question != null ? (
          <Row>
            <div className="d-flex flex-column mb-3 justify-content-start align-items-start">
              <Title level={5}>Hint :</Title>
            </div>
            {hintOptions.map((el, index) => {
              return !el.value.includes("Solution") ? (
                <Col span={24}>
                  <div className="d-flex flex-column mb-3 justify-content-start align-items-start">
                    <Tooltip title={() => returnTooltipMsg(el.value)}>
                      <Space>
                        <Title level={5} className="hintTitleIndex">
                          {index + 1}. {el.label}
                        </Title>
                        <InfoCircleOutlined className="tableIdIconstyle" />
                      </Space>
                    </Tooltip>
                    {editIndex.includes(el.value)
                      ? questionDetailsstate.question &&
                        questionDetailsstate.question !== undefined && (
                          <TextArea
                            className="marginBottomAIHINT"
                            autoSize={{ minRows: 2, maxRows: 6 }}
                            //   defaultValue={questionDetailsstate.question[`${el.value}Ai`]}
                            value={
                              questionDetailsstate.question[`${el.value}Ai`]
                            }
                            onChange={(e) => handleEditedFeedback(el.value, e)}
                          >
                            {" "}
                          </TextArea>
                        )
                      : questionDetailsstate.question &&
                        questionDetailsstate.question !== undefined && (
                          <Paragraph className="marginBottomAIHINT">
                            {questionDetailsstate.question[`${el.value}User`] !=
                              undefined &&
                            questionDetailsstate.question[`${el.value}User`] !=
                              null
                              ? questionDetailsstate.question[`${el.value}User`]
                              : questionDetailsstate.question[
                                  `${el.value}Ai`
                                ]}{" "}
                          </Paragraph>
                        )}
                    <Space>
                      {questionDetailsstate.question[`${el.value}Feedback`] !=
                        undefined &&
                      questionDetailsstate.question[`${el.value}Feedback`] !=
                        null &&
                      questionDetailsstate.question[`${el.value}Feedback`] ? (
                        <LikeFilled
                          style={{
                            fontSize: "16px",
                            color: "green",
                          }}
                        />
                      ) : (
                        <LikeOutlined
                          onClick={() => {
                            question.tags != null &&
                              !question.tags.split(",").includes("HV") &&
                              handleAiFeedback(el.value, true);
                          }}
                          style={{
                            fontSize: "16px",
                            color:
                              questionDetailsstate.question[
                                `${el.value}Feedback`
                              ] == null
                                ? "black"
                                : "gray",
                          }}
                        />
                      )}
                      {questionDetailsstate.question[`${el.value}Feedback`] !=
                        undefined &&
                      questionDetailsstate.question[`${el.value}Feedback`] !=
                        null &&
                      !questionDetailsstate.question[`${el.value}Feedback`] ? (
                        <DislikeFilled
                          style={{
                            fontSize: "16px",
                            color: "red",
                            marginLeft: "15px",
                          }}
                        />
                      ) : (
                        <DislikeOutlined
                          onClick={() => {
                            question.tags != null &&
                              !question.tags.split(",").includes("HV") &&
                              handleAiFeedback(el.value, false);
                          }}
                          style={{
                            fontSize: "16px",
                            color:
                              questionDetailsstate.question[
                                `${el.value}Feedback`
                              ] == null
                                ? "black"
                                : "gray",
                            marginLeft: "15px",
                          }}
                        />
                      )}
                      {question.tags != null &&
                      !question.tags.split(",").includes("HV") ? (
                        <Space>
                          <Button
                            type="text"
                            style={{
                              color: editIndex.includes(el.value)
                                ? "#000000E0"
                                : "#008dc4",
                            }}
                            onClick={() => {
                              handleEditFeedback(el.value, index);
                            }}
                          >
                            {editIndex.includes(el.value) ? "Close" : "Edit"}
                          </Button>
                          {editIndex.includes(el.value) && (
                            <Button
                              type="text"
                              onClick={() => {
                                handleResetFeedback(el.value, index);
                              }}
                            >
                              Reset
                            </Button>
                          )}
                        </Space>
                      ) : null}
                    </Space>
                  </div>
                </Col>
              ) : null;
            })}
            <div className="d-flex flex-column mb-3 justify-content-start align-items-start">
              <Title level={5}>Solution :</Title>
            </div>
            {hintOptions.map((el, index) => {
              return el.value.includes("Solution") ? (
                <Col span={24}>
                  <div className="d-flex flex-column mb-3 justify-content-start align-items-start">
                    <Tooltip title={() => returnTooltipMsg(el.value)}>
                      <Space>
                        <Title level={5} className="hintTitleIndex">
                          {el.label}
                        </Title>
                        <InfoCircleOutlined className="tableIdIconstyle" />
                      </Space>
                    </Tooltip>
                    {editIndex.includes(el.value)
                      ? questionDetailsstate.question &&
                        questionDetailsstate.question !== undefined && (
                          <TextArea
                            className="marginBottomAIHINT"
                            autoSize={{ minRows: 2, maxRows: 6 }}
                            //   defaultValue={questionDetailsstate.question[`${el.value}Ai`]}
                            value={
                              questionDetailsstate.question[`${el.value}`]
                                ? questionDetailsstate.question[`${el.value}`]
                                : ""
                            }
                            onChange={(e) => handleEditedFeedback(el.value, e)}
                          >
                            {" "}
                          </TextArea>
                          //   <RickQuestionComponent
                          //     required={true}
                          //     name={el.value}
                          //     triggerFunction={(data) => {
                          //       handleEditedFeedback(el.value, data);
                          //       //   onClickHandler(name, data);
                          //     }}
                          //     defaultValue={
                          //       questionDetailsstate.question[`${el.value}`]
                          //         ? questionDetailsstate.question[`${el.value}`]
                          //         : ""
                          //     }
                          //     handleCommentClick={() => {}}
                          //     title={el.label}
                          //     controlName={"normalize"}
                          //     onBtnClick={() => {
                          //       //   setIsContentEdit(false);
                          //       handleEditFeedback(el.value, index);
                          //       //   onClickHandler(name, content);
                          //     }}
                          //   />
                        )
                      : questionDetailsstate.question &&
                        questionDetailsstate.question !== undefined && (
                          <QuestionTextProvider
                            className="marginBottomAIHINT"
                            content={getAppendImgUrl(
                              questionDetailsstate.question[
                                `${el.value}User`
                              ] != undefined &&
                                questionDetailsstate.question[
                                  `${el.value}User`
                                ] != null
                                ? questionDetailsstate.question[
                                    `${el.value}User`
                                  ]
                                : questionDetailsstate.question[`${el.value}`]
                            )}
                          />
                        )}
                    <Space>
                      {questionDetailsstate.question[`${el.value}Feedback`] !=
                        undefined &&
                      questionDetailsstate.question[`${el.value}Feedback`] !=
                        null &&
                      questionDetailsstate.question[`${el.value}Feedback`] ? (
                        <LikeFilled
                          style={{
                            fontSize: "16px",
                            color: "green",
                          }}
                        />
                      ) : (
                        <LikeOutlined
                          onClick={() => {
                            question.tags != null &&
                              !question.tags.split(",").includes("HV") &&
                              handleAiFeedback(el.value, true);
                          }}
                          style={{
                            fontSize: "16px",
                            color:
                              questionDetailsstate.question[
                                `${el.value}Feedback`
                              ] == null
                                ? "black"
                                : "gray",
                          }}
                        />
                      )}
                      {questionDetailsstate.question[`${el.value}Feedback`] !=
                        undefined &&
                      questionDetailsstate.question[`${el.value}Feedback`] !=
                        null &&
                      !questionDetailsstate.question[`${el.value}Feedback`] ? (
                        <DislikeFilled
                          style={{
                            fontSize: "16px",
                            color: "red",
                            marginLeft: "15px",
                          }}
                        />
                      ) : (
                        <DislikeOutlined
                          onClick={() => {
                            question.tags != null &&
                              !question.tags.split(",").includes("HV") &&
                              handleAiFeedback(el.value, false);
                          }}
                          style={{
                            fontSize: "16px",
                            color:
                              questionDetailsstate.question[
                                `${el.value}Feedback`
                              ] == null
                                ? "black"
                                : "gray",
                            marginLeft: "15px",
                          }}
                        />
                      )}
                      {question.tags != null &&
                      !question.tags.split(",").includes("HV") ? (
                        <Space>
                          <Button
                            type="text"
                            style={{
                              color: editIndex.includes(el.value)
                                ? "#000000E0"
                                : "#008dc4",
                            }}
                            onClick={() => {
                              handleEditFeedback(el.value, index);
                            }}
                          >
                            {editIndex.includes(el.value) ? "Close" : "Edit"}
                          </Button>
                          {editIndex.includes(el.value) && (
                            <Button
                              type="text"
                              onClick={() => {
                                handleResetFeedback(el.value, index);
                              }}
                            >
                              Reset
                            </Button>
                          )}
                        </Space>
                      ) : null}
                    </Space>
                  </div>
                </Col>
              ) : null;
            })}
            {questionDetailsstate.question.concepts?.length > 0 ? (
              <>
                <div className="d-flex flex-column mb-3 justify-content-start align-items-start">
                  <Tooltip title={() => returnTooltipMsg("concept")}>
                    <Space>
                      <Title level={5} className="hintTitleIndex">
                        Concepts:
                      </Title>
                      <InfoCircleOutlined className="tableIdIconstyle" />
                    </Space>
                  </Tooltip>
                </div>
                <Col span={24}>
                  <Table
                    dataSource={questionDetailsstate.question.concepts}
                    pagination={false}
                    size="small"
                    bordered
                    rowKey="conceptId"
                    className="concept-status-table"
                    columns={[
                      {
                        title: "Concept",
                        dataIndex: "concept",
                        key: "concept",
                        width: "40%",
                        render: (text) => (
                          <span style={{ fontWeight: 500 }}>{text}</span>
                        ),
                      },
                      {
                        title: (
                          <HeaderCell bgColor="#a9d18e">Primary</HeaderCell>
                        ),
                        key: "primary",
                        align: "center",
                        width: "20%",
                        render: (_, record) => (
                          <ConceptStatusSquare
                            type="checkbox"
                            borderColor="#54a447"
                            disabled={isAlreadyVerified}
                            checked={
                              conceptStatuses[record.conceptId] === "primary"
                            }
                            onChange={() =>
                              handleConceptStatusChange(
                                record.conceptId,
                                "primary"
                              )
                            }
                          />
                        ),
                      },
                      {
                        title: (
                          <HeaderCell bgColor="#ffe699">Secondary</HeaderCell>
                        ),
                        key: "secondary",
                        align: "center",
                        width: "20%",
                        render: (_, record) => (
                          <ConceptStatusSquare
                            type="checkbox"
                            borderColor="#e2b13c"
                            disabled={isAlreadyVerified}
                            checked={
                              conceptStatuses[record.conceptId] === "secondary"
                            }
                            onChange={() =>
                              handleConceptStatusChange(
                                record.conceptId,
                                "secondary"
                              )
                            }
                          />
                        ),
                      },
                      {
                        title: (
                          <HeaderCell bgColor="#f4b183">Incorrect</HeaderCell>
                        ),
                        key: "incorrect",
                        align: "center",
                        width: "20%",
                        render: (_, record) => (
                          <ConceptStatusSquare
                            type="checkbox"
                            borderColor="#c00000"
                            disabled={isAlreadyVerified}
                            checked={
                              conceptStatuses[record.conceptId] === "incorrect"
                            }
                            onChange={() =>
                              handleConceptStatusChange(
                                record.conceptId,
                                "incorrect"
                              )
                            }
                          />
                        ),
                      },
                    ]}
                  />
                </Col>
              </>
            ) : null}
            {question.tags != null &&
            !question.tags.split(",").includes("HV") ? (
              <Col
                span={24}
                className="d-flex flex-row justify-content-between mt-4"
              >
                <Space size={"large"}>
                  <Button
                    type="default"
                    onClick={() => {
                      handleResetAllFeedback(questionDetailsstate);
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="primary"
                    disabled={isAlreadyVerified}
                    onClick={() => {
                      handleSaveFeedback(questionDetailsstate);
                    }}
                  >
                    Save
                  </Button>
                </Space>
                <div
                  className="d-flex flex-row align-items-center border rounded p-1 pl-2 pr-2"
                  style={{
                    borderColor: "#d9d9d9",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    handleReport();
                  }}
                >
                  <img src={ReportLog} />
                  <span style={{ color: "#333333", marginLeft: "8px" }}>
                    {" Report Question"}
                  </span>
                </div>
              </Col>
            ) : null}
          </Row>
        ) : (
          <></>
        )
      ) : (
        <>
          <Skeleton active paragraph={{ rows: 2 }}></Skeleton>
          <br />
          <Skeleton active paragraph={{ rows: 2 }}></Skeleton>
          <br />
          <Skeleton active paragraph={{ rows: 2 }}></Skeleton>
        </>
      )}
    </>
  );
};

AIHintSliderMain.propTypes = {
  question: PropTypes.object,
  closeQuesContentSlider: PropTypes.any,
  setRefresh: PropTypes.func,
  setUserVerifiedCount: PropTypes.func,
};

export default AIHintSliderMain;
